import { useState } from "react";
import { booker } from "@/content";

const faqs = booker.faq.items;

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" itemScope itemType="https://schema.org/FAQPage" className="py-24 bg-gray-50 dark:bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-yellow-200/25 dark:bg-yellow-500/10 blur-[110px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full bg-cyan-200/25 dark:bg-cyan-500/10 blur-[100px] pointer-events-none" />

      <div className="max-w-3xl mx-auto px-6 relative z-10">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-gray-200 dark:bg-slate-800/60 text-gray-600 dark:text-slate-400 text-xs font-semibold tracking-widest uppercase mb-4">{booker.faq.badge}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-4">{booker.faq.title}</h2>
          <p className="text-gray-600 dark:text-slate-400 text-lg">{booker.faq.subtitle}</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className={`rounded-2xl border transition-all duration-200 overflow-hidden ${
                open === i
                  ? "border-transparent bg-white dark:bg-white/[0.06] shadow-sm"
                  : "border-gray-200 dark:border-white/[0.09] bg-white/60 dark:bg-white/[0.03]"
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span itemProp="name" className={`font-semibold text-sm md:text-base pr-4 ${open === i ? "text-gray-900 dark:text-white" : "text-gray-700 dark:text-slate-300"}`}>
                  {faq.q}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  open === i
                    ? `bg-gradient-to-br ${faq.gradient} rotate-45`
                    : "bg-gray-100 dark:bg-slate-800"
                }`}>
                  <i className={`ri-add-line text-sm ${open === i ? "text-white" : "text-gray-600 dark:text-slate-400"}`}></i>
                </div>
              </button>
              {open === i && (
                <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <div itemProp="text" className="px-6 pb-5">
                    <p className="text-gray-600 dark:text-slate-400 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
